<template>
  <SettingPanel :title='$t("stay_in_the_loop")'>
    <div class='mr-6 text-body-2'> {{ $t('opt_in_to_news') }}</div>
    <v-switch
      v-model='enabledCommunication'
      class='mr-0'
      :loading='enabledCommunicationLoading'
      :disabled='enabledCommunicationLoading'
      inset
    ></v-switch>
  </SettingPanel>
</template>

<script>
  import SettingPanel from '../../panels/settings/Base'

  export default {
    name: 'EnableCommunication',
    components: {
      SettingPanel
    },
    data() {
      return {
        enabledCommunicationLoading: false
      }
    },
    computed: {
      enabledCommunication: {
        get() {
          return this.user.enabled_communication;
        },
        set(val) {
          this.enabledCommunicationLoading = true;

          const query = {
            enabled_communication: val,
            userId: this.user.id
          }
          return this.$store.dispatch('auth/updateEnabledCommunication', query).finally(() => {
            this.enabledCommunicationLoading = false;
          })
        }
      },
      user() {
        return this.$store.getters['auth/user'];
      }
    }
  }
</script>

<style scoped>

</style>
